import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { InventoryTransformations_ModuleContextService } from './InventoryTransformations.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class InventoryTransformations_total_inventory_transformation_target_material_widget_ComponentContextService {
  private readonly moduleContext: InventoryTransformations_ModuleContextService;

  constructor(moduleContext: InventoryTransformations_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'total_inventory_transformation_target_material_widget',
      type: ComponentType.widget
    }
  }
}